import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { createCoroutineUninterceptedGeneratorVersion2gduom218i9ay as createCoroutineUninterceptedGeneratorVersion } from '../coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
} from '../Result.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../coroutines/intrinsics/Intrinsics.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../coroutines/CoroutineContextImpl.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../coroutines/Continuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function sequence(block) {
  // Inline function 'kotlin.sequences.Sequence' call
  return new (sequence$$inlined$Sequence$1())(block);
}
var SequenceScopeClass;
function SequenceScope() {
  if (SequenceScopeClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SequenceScope', VOID, VOID, VOID, [1]);
    SequenceScopeClass = $;
  }
  return SequenceScopeClass;
}
function iterator(block) {
  var iterator = new (SequenceBuilderIterator())();
  iterator.nextStep_1 = createCoroutineUninterceptedGeneratorVersion(block, iterator, iterator);
  return iterator;
}
function nextNotReady($this) {
  if (!$this.hasNext_bitz1p_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
  else
    return $this.next_20eer_k$();
}
function exceptionalState($this) {
  switch ($this.state_1) {
    case 4:
      return NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
    case 5:
      return IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Iterator has failed.');
    default:
      return IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Unexpected state of the iterator: ' + $this.state_1);
  }
}
var SequenceBuilderIteratorClass;
function SequenceBuilderIterator() {
  if (SequenceBuilderIteratorClass === VOID) {
    class $ extends SequenceScope() {
      constructor() {
        super();
        this.state_1 = 0;
        this.nextValue_1 = null;
        this.nextIterator_1 = null;
        this.nextStep_1 = null;
      }
      hasNext_bitz1p_k$() {
        while (true) {
          switch (this.state_1) {
            case 0:
              break;
            case 1:
              if (ensureNotNull(this.nextIterator_1).hasNext_bitz1p_k$()) {
                this.state_1 = 2;
                return true;
              } else {
                this.nextIterator_1 = null;
              }

              break;
            case 4:
              return false;
            case 3:
            case 2:
              return true;
            default:
              throw exceptionalState(this);
          }
          this.state_1 = 5;
          var step = ensureNotNull(this.nextStep_1);
          this.nextStep_1 = null;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
          step.resumeWith_rk9gbt_k$(tmp$ret$1);
        }
      }
      next_20eer_k$() {
        switch (this.state_1) {
          case 0:
          case 1:
            return nextNotReady(this);
          case 2:
            this.state_1 = 1;
            return ensureNotNull(this.nextIterator_1).next_20eer_k$();
          case 3:
            this.state_1 = 0;
            var result = this.nextValue_1;
            this.nextValue_1 = null;
            return result;
          default:
            throw exceptionalState(this);
        }
      }
      *yield_3xhcex_k$(value, $completion) {
        this.nextValue_1 = value;
        this.state_1 = 3;
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        (yield () => {
          this.nextStep_1 = $completion;
          return get_COROUTINE_SUSPENDED();
        });
        return Unit_instance;
      }
      resumeWith_lgtnnr_k$(result) {
        // Inline function 'kotlin.getOrThrow' call
        throwOnFailure(result);
        _Result___get_value__impl__bjfvqg(result);
        this.state_1 = 4;
      }
      resumeWith_rk9gbt_k$(result) {
        return this.resumeWith_lgtnnr_k$(result);
      }
      get_context_h02k06_k$() {
        return EmptyCoroutineContext_instance;
      }
    }
    initMetadataForClass($, 'SequenceBuilderIterator', SequenceBuilderIterator, VOID, [Continuation()], [1]);
    SequenceBuilderIteratorClass = $;
  }
  return SequenceBuilderIteratorClass;
}
var sequence$$inlined$Sequence$1Class;
function sequence$$inlined$Sequence$1() {
  if (sequence$$inlined$Sequence$1Class === VOID) {
    class $ {
      constructor($block) {
        this.$block_1 = $block;
      }
      iterator_jk1svi_k$() {
        return iterator(this.$block_1);
      }
    }
    initMetadataForClass($);
    sequence$$inlined$Sequence$1Class = $;
  }
  return sequence$$inlined$Sequence$1Class;
}
//region block: exports
export {
  iterator as iterator3f5i676wpaa3g,
  sequence as sequence2vgswtrxvqoa7,
};
//endregion

//# sourceMappingURL=SequenceBuilder.mjs.map
